import React from "react";
import Header from "../components/FrontPage/Header/Header";
import Footer from "../components/Footer/Footer";
import LeftDrawer from "../components/Dashboard/Drawers/LeftDrawer";
import CTI from "./static/CTI";
import ScrollToTopOnMount from "../helpers/ScrollToTop";

const CTIPage = ({ USER }) => {
  return (
    <>
      <ScrollToTopOnMount />
      <Header />
      <CTI />
      <Footer />
      {USER && <LeftDrawer small />}
    </>
  );
};

export default CTIPage;
